import { showToast } from "@cerebruminc/cerebellum";

/**
 * method to show neutral toast message
 * @param text message string
 */
export const showMessage = (text: string) => {
	showToast({
		id: `message-toast-${Date.now()}`,
		message: text,
		tone: "neutral",
	});
};
